$size-s: 20px;
$size-m: 24px;
$size-l: 28px;

:host {
  @apply relative inline-flex;
}

:host([scale="s"]) {
  @apply h-5 w-5;
}

:host([scale="m"]) {
  @apply h-6 w-6;
}

:host([scale="l"]) {
  @apply h-8 w-8;
}

.swatch {
  @apply overflow-hidden;
  block-size: inherit;
  inline-size: inherit;

  rect {
    @apply transition-all duration-150 ease-in-out;
  }
}

.swatch--no-color {
  rect {
    fill: var(--calcite-color-foreground-1);
  }

  line {
    stroke: var(--calcite-color-status-danger);
  }
}

.checker {
  fill: #cacaca;
}

@include base-component();
